import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import './ConfirmationDialog.scss';

export interface ConfirmationDialogProps {
    title?: string;
    icon?: JSX.Element;
    visible?: boolean;
    content: string | JSX.Element;
    onCancel: () => void;
    onConfirm?: () => void;
}

const ConfirmationDialog = ({
    title,
    visible,
    icon,
    content,
    onCancel,
    onConfirm,
}: ConfirmationDialogProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <Modal
            className="ConfirmationDialog__container"
            centered
            destroyOnClose
            open={visible}
            closable={false}
            maskClosable={false}
            footer={null}
        >
            {title ? <h3 className="ConfirmationDialog__title">{title}</h3> : null}
            <Row wrap={false} gutter={16} className="ConfirmationDialog__content-container">
                {icon ? <Col flex="none">{icon}</Col> : null}
                <Col flex="auto">
                    <span className="ConfirmationDialog__content">{content}</span>
                </Col>
            </Row>
            <Row justify="end" gutter={16}>
                <Col>
                    <Button className="ConfirmationDialog__button" onClick={onCancel}>
                        {onConfirm ? t('COMMON.NO') : t('COMMON.OK')}
                    </Button>
                </Col>
                {onConfirm ? (
                    <Col>
                        <Button className="ConfirmationDialog__button" onClick={onConfirm}>
                            {t('COMMON.YES')}
                        </Button>
                    </Col>
                ) : null}
            </Row>
        </Modal>
    );
};

export default ConfirmationDialog;
